// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TufU","col":"styles_col__3DLlB"};